export const getUTMParams = () => {
  const search = window.location.search || window.location.hash.split('?')[1] || '';

  const params = new URLSearchParams(search);
  const utmData = {};
  const keys = Array.from(params.keys());

  keys.forEach((key) => {
    if (key.startsWith('utm_')) {
      utmData[key] = params.get(key);
    }
  });

  return Object.keys(utmData).length ? utmData : null;
};
